export default __webpack_public_path__ + "adf85afefecb96c0a2c903e521543792.png";